import React from 'react';
import { func, shape, bool, string } from 'prop-types';
import OutlinedTextField from '../../forms/textFields/OutlinedTextField';
import Toggle from '../../shared/Toggle';
import SelectDropdown from '../../forms/SelectDropdown';
import { descriptionFormPropTypes } from '../../../proptypes/shared';
import { activities } from '../../../utils/activity_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import FormButtons from '../FormButtons';
import { form, formField, dateSelect, activitySelect, formToggle, formDateActivity } from './styles/styles.module.scss';
import DatePicker from '../../shared/DatePicker';

const DescriptionForm = ({ initialChangeset, changeset, updateChangeset, handleDescriptionSave, isSubmitting, closeDescriptionForm, locale }) => {
  const mapCreatorStrings = StringConstantsMixin.strings.MAP_CREATOR;

  const onChange = e => {
    const { name, value } = e.target;
    updateChangeset(prevState => ({ ...prevState, [name]: value }));
  };

  const onDateChange = date => {
    updateChangeset(prevState => ({ ...prevState, date }));
  };

  const onSelect = e => {
    const value = e.currentTarget.dataset.value;
    const updatedActivity = activities.find(activity => activity.value === value);
    updateChangeset(prevState => ({ ...prevState, activity: updatedActivity }));
  };

  const onToggle = () => {
    updateChangeset(prevState => ({ ...prevState, isPrivate: !prevState.isPrivate }));
  };

  const onClear = () => {
    updateChangeset(initialChangeset);
    closeDescriptionForm();
  };

  const saveDescriptionForm = e => {
    closeDescriptionForm();
    handleDescriptionSave(e, true);
  };

  return (
    <form className={form} onSubmit={saveDescriptionForm}>
      <div>
        <OutlinedTextField
          className={formField}
          name="title"
          changeHandler={onChange}
          value={changeset.title}
          label={mapCreatorStrings.TITLE_LABEL}
          type="text"
        />
      </div>
      <div>
        <OutlinedTextField
          name="description"
          className={formField}
          changeHandler={onChange}
          value={changeset.description || ''}
          label={mapCreatorStrings.DESCRIPTION_LABEL}
          type="text"
          multiline
          rows={3}
        />
      </div>
      <div className={formDateActivity}>
        <SelectDropdown
          id="activity-select"
          ariaLabel={mapCreatorStrings.ACTIVITY}
          nullable
          handleChange={onSelect}
          options={activities}
          defaultItem={changeset.activity}
          className={activitySelect}
          name="activity"
        />
        <DatePicker locale={locale} abbreviateMonth date={changeset.date} className={dateSelect} onChange={onDateChange} disableFuture={false} />
      </div>
      <Toggle className={formToggle} inputId="mapPrivacyToggle" checked={changeset.isPrivate} onChange={onToggle} label={mapCreatorStrings.PRIVATE} />

      <FormButtons onCancel={onClear} disabled={isSubmitting} />
    </form>
  );
};

DescriptionForm.propTypes = {
  updateChangeset: func.isRequired,
  changeset: shape(descriptionFormPropTypes),
  initialChangeset: shape(descriptionFormPropTypes),
  isSubmitting: bool,
  handleDescriptionSave: func,
  locale: string
};

DescriptionForm.defaultProps = {
  isSubmitting: false,
  handleDescriptionSave: () => {},
  locale: 'en-US'
};

export default DescriptionForm;
